import {Calculator} from 'lucide-react'
import { Link } from 'react-router-dom'

const silos = [
  {
    title: 'Budgeting & Net Worth',
    links: [
      { to: '/calculators/budget-50-30-20', label: '50/30/20 Budget Calculator' },
      { to: '/calculators/net-worth', label: 'Net Worth Calculator' },
      { to: '/calculators/emergency-fund', label: 'Emergency Fund Calculator' },
    ],
  },
  {
    title: 'Loans, Credit & Debt',
    links: [
      { to: '/calculators/mint-loan', label: 'Mint Loan & Amortization' },
      { to: '/calculators/credit-card-payoff', label: 'Credit Card Payoff' },
      { to: '/calculators/mortgage-payoff', label: 'Mortgage Payoff' },
    ],
  },
  {
    title: 'Web3 & Crypto Mint Gas',
    links: [
      { to: '/calculators/nft-mint-cost', label: 'NFT Mint Cost Estimator' },
      { to: '/calculators/solana-mint-cost', label: 'Solana Mint Cost' },
    ],
  },
  {
    title: 'Numismatic Coin & Bullion',
    links: [
      { to: '/calculators/silver-coin-value', label: 'Silver Coin Value' },
      { to: '/calculators/gold-eagle-mint', label: 'Gold Eagle Mint Value' },
    ],
  },
]

function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-slate-950">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500/15 text-emerald-400">
                <Calculator className="h-4 w-4" />
              </span>
              <span className="text-base font-bold text-slate-50">
                Mint
                {' '}
                <span className="text-emerald-400">Calculator</span>
              </span>
            </Link>
            <p className="mt-3 text-sm text-slate-500">
              Free, precise financial, crypto, and numismatic calculators built for the community left behind by Intuit Mint's shutdown.
            </p>
          </div>
          {silos.map(silo => (
            <div key={silo.title}>
              <p className="text-sm font-semibold text-slate-200">{silo.title}</p>
              <ul className="mt-3 space-y-2">
                {silo.links.map(link => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-slate-500 transition-colors hover:text-emerald-400">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-slate-800 pt-6">
          <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
            <p className="text-xs text-slate-600">
              © 2024 Mint Calculator (www.mintcalculator.com). All calculations are estimates for informational purposes only.
            </p>
            <div className="flex flex-wrap gap-4 text-xs text-slate-500">
              <Link to="/about" className="hover:text-emerald-400">About Us</Link>
              <Link to="/disclaimer" className="hover:text-emerald-400">Financial Disclaimer</Link>
              <Link to="/privacy-policy" className="hover:text-emerald-400">Privacy Policy</Link>
              <Link to="/terms-of-service" className="hover:text-emerald-400">Terms of Service</Link>
              <Link to="/contact" className="hover:text-emerald-400">Contact</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
